function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import appApis, { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import trae from 'trae';

// declare service gtw
var appApisGTW = trae.create({
  baseUrl: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8084')
});
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = "Bearer " + window.userInfo.accessToken;
  return config;
};
appApisGTW.before(beforeMiddleware);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = "/data_strategy";
var DOMAIN_PLAN_DATA = "/plan_data";
var DOMAIN_DIVISION = "/division";
var DOMAIN_SYSTEM = "/system";
var DOMAIN_PLAN_PILAR = "/plan_pilar";
var DOMAIN_ENTITY = "/entity";
var DOMAIN_OPORTUNITY = "/oportunity";
var DOMAIN_MVP = "/mvp";
var DOMAIN_INDUSTRY = "/industry";
export default {
  getPlanDataAll: function getPlanDataAll(data) {
    var _this = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_DATA + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.getPlanDataAll(data);
      });
    });
  },
  getPlanDataById: function getPlanDataById(data) {
    var _this2 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_DATA + '/get/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this2.getPlanDataById(data);
      });
    });
  },
  createPlanData: function createPlanData(data) {
    var _this3 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_DATA + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this3.createPlanData(data);
      });
    });
  },
  updatePlanData: function updatePlanData(data) {
    var _this4 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_DATA + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this4.updatePlanData(data);
      });
    });
  },
  deletePlanDataById: function deletePlanDataById(data) {
    var _this5 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_DATA + '/delete/' + data.plan_data_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this5.deletePlanDataById(data);
      });
    });
  },
  getDivisionAll: function getDivisionAll(data) {
    var _this6 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DIVISION + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this6.getDivisionAll(data);
      });
    });
  },
  getDivisionById: function getDivisionById(data) {
    var _this7 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DIVISION + '/get/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this7.getDivisionById(data);
      });
    });
  },
  createDivision: function createDivision(data) {
    var _this8 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DIVISION + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this8.createDivision(data);
      });
    });
  },
  updateDivision: function updateDivision(data) {
    var _this9 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DIVISION + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this9.updateDivision(data);
      });
    });
  },
  deleteDivisionById: function deleteDivisionById(data) {
    var _this0 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_DIVISION + '/delete/' + data.division_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this0.deleteDivisionById(data);
      });
    });
  },
  getSystemAll: function getSystemAll(data) {
    var _this1 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_SYSTEM + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this1.getSystemAll(data);
      });
    });
  },
  getSystemById: function getSystemById(data) {
    var _this10 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_SYSTEM + '/get/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this10.getSystemById(data);
      });
    });
  },
  createSystem: function createSystem(data) {
    var _this11 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_SYSTEM + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this11.createSystem(data);
      });
    });
  },
  updateSystem: function updateSystem(data) {
    var _this12 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_SYSTEM + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this12.updateSystem(data);
      });
    });
  },
  deleteSystemById: function deleteSystemById(data) {
    var _this13 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_SYSTEM + '/delete/' + data.system_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this13.deleteSystemById(data);
      });
    });
  },
  getPlanPilarAll: function getPlanPilarAll(data) {
    var _this14 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_PILAR + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this14.getPlanPilarAll(data);
      });
    });
  },
  getPlanPilarById: function getPlanPilarById(data) {
    var _this15 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_PILAR + '/get/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this15.getPlanPilarById(data);
      });
    });
  },
  createPlanPilar: function createPlanPilar(data) {
    var _this16 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_PILAR + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this16.createPlanPilar(data);
      });
    });
  },
  updatePlanPilar: function updatePlanPilar(data) {
    var _this17 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_PILAR + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this17.updatePlanPilar(data);
      });
    });
  },
  deletePlanPilarById: function deletePlanPilarById(data) {
    var _this18 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_PLAN_PILAR + '/delete/' + data.plan_pilar_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this18.deletePlanPilarById(data);
      });
    });
  },
  getEntityAll: function getEntityAll(data) {
    var _this19 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ENTITY + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this19.getEntityAll(data);
      });
    });
  },
  getEntityById: function getEntityById(data) {
    var _this20 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ENTITY + '/get/' + data.entity_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this20.getEntityById(data);
      });
    });
  },
  createEntity: function createEntity(data) {
    var _this21 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ENTITY + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this21.createEntity(data);
      });
    });
  },
  updateEntity: function updateEntity(data) {
    var _this22 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ENTITY + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this22.updateEntity(data);
      });
    });
  },
  deleteEntityById: function deleteEntityById(data) {
    var _this23 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ENTITY + '/delete/' + data.entity_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this23.deleteEntityById(data);
      });
    });
  },
  getOportunityAll: function getOportunityAll(data) {
    var _this24 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_OPORTUNITY + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this24.getOportunityAll(data);
      });
    });
  },
  getOportunityById: function getOportunityById(data) {
    var _this25 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_OPORTUNITY + '/get/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this25.getOportunityById(data);
      });
    });
  },
  createOportunity: function createOportunity(data) {
    var _this26 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_OPORTUNITY + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this26.createOportunity(data);
      });
    });
  },
  updateOportunity: function updateOportunity(data) {
    var _this27 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_OPORTUNITY + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this27.updateOportunity(data);
      });
    });
  },
  deleteOportunityById: function deleteOportunityById(data) {
    var _this28 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_OPORTUNITY + '/delete/' + data.entity_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this28.deleteOportunityById(data);
      });
    });
  },
  getMvpAll: function getMvpAll(data) {
    var _this29 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_MVP + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this29.getMvpAll(data);
      });
    });
  },
  getMvpById: function getMvpById(data) {
    var _this30 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_MVP + '/get/' + data.mvp_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this30.getMvpById(data);
      });
    });
  },
  createMvp: function createMvp(data) {
    var _this31 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_MVP + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this31.createMvp(data);
      });
    });
  },
  updateMvp: function updateMvp(data) {
    var _this32 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_MVP + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this32.updateMvp(data);
      });
    });
  },
  deleteMvpById: function deleteMvpById(data) {
    var _this33 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_MVP + '/delete/' + data.mvp_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this33.deleteMvpById(data);
      });
    });
  },
  getIndustryAll: function getIndustryAll(data) {
    var _this34 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_INDUSTRY + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this34.getIndustryAll(data);
      });
    });
  },
  getIndustryById: function getIndustryById(data) {
    var _this35 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_INDUSTRY + '/get/' + data.industry_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this35.getIndustryById(data);
      });
    });
  },
  createIndustry: function createIndustry(data) {
    var _this36 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_INDUSTRY + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this36.createIndustry(data);
      });
    });
  },
  updateIndustry: function updateIndustry(data) {
    var _this37 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_INDUSTRY + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this37.updateIndustry(data);
      });
    });
  },
  deleteIndustryById: function deleteIndustryById(data) {
    var _this38 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_INDUSTRY + '/delete/' + data.industry_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this38.deleteIndustryById(data);
      });
    });
  }
};